var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blue--text text--darken-4 ma-0 pa-0"},[_c('p',{staticClass:"ma-0 pa-0"},[_vm._v(_vm._s(_vm.number))]),_vm._v(" "),(_vm.start)?_c('p',{staticClass:"ma-0 py-0 caption grey--text text--darken-3"},[_vm._v("from "+_vm._s(_vm._f("dateEU")(_vm.start,'DD/MM/YYYY'))+"  to  "+_vm._s(_vm._f("dateEU")(_vm.end,'DD/MM/YYYY')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }